// Sorters and helpers extracted from meta.ts to break circular dependencies

export function isValue(val: any): boolean {
  return val !== null && val !== undefined;
}

export function compareBasic(a: any, b: any): number {
  return a > b ? 1 : a < b ? -1 : 0;
}

type MRT_RowData = Record<string, any>;
type MRT_Row<T> = {
  getValue: (id: string) => any;
};

export function numberSort(
  rowA: MRT_Row<MRT_RowData>,
  rowB: MRT_Row<MRT_RowData>,
  columnId: string
) {
  const a = getRowValueByColumnID(rowA, columnId);
  const b = getRowValueByColumnID(rowB, columnId);
  if (a === b) return 0;

  if (!isValue(a)) {
    return -1;
  }
  if (!isValue(b)) {
    return 1;
  }

  return compareBasic(a, b);
}

export function coordinatesSort(
  rowA: MRT_Row<MRT_RowData>,
  rowB: MRT_Row<MRT_RowData>,
  columnId: string
) {
  let a = getRowValueByColumnID(rowA, columnId);
  let b = getRowValueByColumnID(rowB, columnId);

  if (!Array.isArray(a)) a = JSON.stringify([0, 0]);
  if (!Array.isArray(b)) b = JSON.stringify([0, 0]);

  if (
    (typeof a === "number" && typeof b === "number") ||
    (typeof a === "string" && typeof b === "string")
  )
    return a > b ? 1 : a < b ? -1 : 0;

  a = `${a}`;
  b = `${b}`;

  return a > b ? 1 : a < b ? -1 : 0;
}

export function numberSortWithCustom(
  rowA: MRT_Row<MRT_RowData>,
  rowB: MRT_Row<MRT_RowData>,
  columnId: string
) {
  const a = getRowValueByColumnID(rowA, columnId);
  const b = getRowValueByColumnID(rowB, columnId);
  const customNegatives = ["N/A"];

  if (customNegatives.includes(a)) {
    return -1;
  }

  if (customNegatives.includes(b)) {
    return 1;
  }

  return numberSort(rowA, rowB, columnId);
}

export function iconSort(rowA: MRT_Row<MRT_RowData>, rowB: MRT_Row<MRT_RowData>, columnId: string) {
  const a = getRowValueByColumnID(rowA, columnId);
  const b = getRowValueByColumnID(rowB, columnId);
  // @ts-expect-error tricky one
  return (b === null || b === undefined) - (a === null || a === undefined) || +(b > a) || -(b < a);
}

export function getRowValueByColumnID(row: MRT_Row<MRT_RowData>, columnId: string): string & any {
  return row.getValue(columnId);
}
